<template>
  <div class="requests-table">
    <div class="requests-table__row requests-table__row_header">
      <div class="requests-table__cell requests-table__cell_name">Имя</div>
      <div class="requests-table__cell requests-table__cell_address">Страна, город</div>
      <div class="requests-table__cell requests-table__cell_phone">Номер</div>
      <div class="requests-table__cell requests-table__cell_email">Email/Ссылка</div>
      <div class="requests-table__cell requests-table__cell_age">Возраст</div>
      <div class="requests-table__cell requests-table__cell_height">Рост</div>
      <div class="requests-table__cell requests-table__cell_photo">Фото</div>
      <div v-show="showActions" class="requests-table__cell requests-table__cell_action">Действия</div>
    </div>
    <div
      class="requests-table__row requests-table__row_content"
      :class="{ 'requests-table__row_new': item.notSeen }"
      v-for="item in requests"
      :key="item.id ? item.id : item.objectID"
      @click="rowClick(item.id ? item.id : item.objectID)"
    >
      <div class="requests-table__cell requests-table__cell_name" v-html="item.name.match(/\S+/g).join('<br>')"></div>
      <div class="requests-table__cell requests-table__cell_address" v-html="item.location.match(/\S+/g).join('<br>')"></div>
      <div class="requests-table__cell requests-table__cell_phone">{{ item.phone }}</div>
      <div class="requests-table__cell requests-table__cell_email">
        <a :href="'mailto:' + item.email" class="requests-table__link">{{ item.email }}</a><br>
        <a :href="item.link" target="_blank" class="requests-table__link">{{ item.link }}</a>
      </div>
      <div class="requests-table__cell requests-table__cell_age">{{ item.age }}</div>
      <div class="requests-table__cell requests-table__cell_height">{{ item.height }}</div>
      <div class="requests-table__cell requests-table__cell_photo">
        <router-link
          tag="button"
          class="requests-table__link"
          :to="{ name: 'AdminRequestView', params: { id: item.id ? item.id : item.objectID } }"
        >
          Подробнее
        </router-link>
      </div>
      <div v-show="showActions" class="requests-table__cell requests-table__cell_action">
        <button
          @click.prevent="$emit('reject-request', item.id ? item.id : item.objectID )"
          class="requests-table__link"
        >
          Отклонить
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RequestsTable',
  props: {
    requests: {
      type: Array,
      required: true
    },
    showActions: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    rowClick(id) {
      this.$router.push({ name: 'AdminRequestView', params: { id } })
    }
  }
}
</script>

<style lang="scss" scoped>
@use "../styles/fonts";
@use "../styles/colors";

.requests-table {
  display: table;
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  &__row {
    font-size: 12px;
    display: flex;
    &_header {
      @include fonts.mo-med;
      font-size: 14px;
    }
    &_new {
      background-color: colors.$bluef0;
    }
    &_content {
      cursor: pointer;
      box-sizing: border-box;
      position: relative;
      &:hover {
          box-shadow: inset 0 -0.5px 0.8px 1.5px colors.$blue03;
      }
    }
  }
  &__cell {
    display: table-cell;
    padding: 16px 5px;
    border-bottom: 1px solid colors.$graye5;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    &_name {
      width: 15%;
      padding-left: 25px;
    }
    &_address {
      width: 17%;
    }
    &_phone {
      width: 14%;
    }
    &_email {
      width: 20%;
    }
    &_age {
      width: 9%;
    }
    &_height {
      width: 9%;
    }
    &_photo {
      width: 9%
    }
    &_action {
      width: 7%;
    }
  }
  &__link {
    @include fonts.mo-reg;
    padding: 0;
    font-size: inherit;
    border: none;
    background-color: transparent;
    text-decoration: none;
    color: colors.$blue03;
    cursor: pointer;
  }
}

@media screen and (max-width: 1328px) {
  .requests-table {
    width: 1328px;
  }
}
</style>